/* tslint:disable */
/* eslint-disable */
/**
 * Appli métier
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: Yoda 1 & 2
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import type { Configuration } from "../configuration"
import type { AxiosPromise, AxiosInstance, RawAxiosRequestConfig } from "axios"
import globalAxios from "axios"
// Some imports not used depending on template conditions
// @ts-ignore
import {
  DUMMY_BASE_URL,
  assertParamExists,
  setApiKeyToObject,
  setBasicAuthToObject,
  setBearerAuthToObject,
  setOAuthToObject,
  setSearchParams,
  serializeDataIfNeeded,
  toPathString,
  createRequestFunction,
  replaceWithSerializableTypeIfNeeded
} from "../common"
// @ts-ignore
import {
  BASE_PATH,
  COLLECTION_FORMATS,
  type RequestArgs,
  BaseAPI,
  RequiredError,
  operationServerMap
} from "../base"
// @ts-ignore
import type { Scoring } from "../model"
// @ts-ignore
import type { ScoringCreationParametersV2 } from "../model"
// @ts-ignore
import type { ScoringDeveloppementParametersV2 } from "../model"
/**
 * ScoringOctroiResourceV2Api - axios parameter creator
 */
export const ScoringOctroiResourceV2ApiAxiosParamCreator = function (
  configuration?: Configuration
) {
  return {
    /**
     *
     * @summary Get note\'s scoring parameters for CREATION/REPRISE notes
     * @param {string} noteId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    checkScoringCreation: async (
      noteId: string,
      options: RawAxiosRequestConfig = {}
    ): Promise<RequestArgs> => {
      // verify required parameter 'noteId' is not null or undefined
      assertParamExists("checkScoringCreation", "noteId", noteId)
      const localVarPath = `/v2.0/scoring/creation/check/{noteId}`.replace(
        "{noteId}",
        encodeURIComponent(String(noteId))
      )
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL)
      let baseOptions
      if (configuration) {
        baseOptions = configuration.baseOptions
      }

      const localVarRequestOptions = { method: "GET", ...baseOptions, ...options }
      const localVarHeaderParameter = {} as any
      const localVarQueryParameter = {} as any

      // authentication oauth2 required
      // oauth required
      await setOAuthToObject(localVarHeaderParameter, "oauth2", [], configuration)

      localVarHeaderParameter["Accept"] = "application/json"

      setSearchParams(localVarUrlObj, localVarQueryParameter)
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {}
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers
      }

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions
      }
    },
    /**
     *
     * @summary Get note\'s scoring parameters for DEVELOPMENT notes
     * @param {string} noteId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    checkScoringDevelopment: async (
      noteId: string,
      options: RawAxiosRequestConfig = {}
    ): Promise<RequestArgs> => {
      // verify required parameter 'noteId' is not null or undefined
      assertParamExists("checkScoringDevelopment", "noteId", noteId)
      const localVarPath = `/v2.0/scoring/development/check/{noteId}`.replace(
        "{noteId}",
        encodeURIComponent(String(noteId))
      )
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL)
      let baseOptions
      if (configuration) {
        baseOptions = configuration.baseOptions
      }

      const localVarRequestOptions = { method: "GET", ...baseOptions, ...options }
      const localVarHeaderParameter = {} as any
      const localVarQueryParameter = {} as any

      // authentication oauth2 required
      // oauth required
      await setOAuthToObject(localVarHeaderParameter, "oauth2", [], configuration)

      localVarHeaderParameter["Accept"] = "application/json"

      setSearchParams(localVarUrlObj, localVarQueryParameter)
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {}
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers
      }

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions
      }
    },
    /**
     *
     * @summary Get scoring by note id
     * @param {string} noteId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getScoring: async (
      noteId: string,
      options: RawAxiosRequestConfig = {}
    ): Promise<RequestArgs> => {
      // verify required parameter 'noteId' is not null or undefined
      assertParamExists("getScoring", "noteId", noteId)
      const localVarPath = `/v2.0/scoring/{noteId}`.replace(
        "{noteId}",
        encodeURIComponent(String(noteId))
      )
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL)
      let baseOptions
      if (configuration) {
        baseOptions = configuration.baseOptions
      }

      const localVarRequestOptions = { method: "GET", ...baseOptions, ...options }
      const localVarHeaderParameter = {} as any
      const localVarQueryParameter = {} as any

      // authentication oauth2 required
      // oauth required
      await setOAuthToObject(localVarHeaderParameter, "oauth2", [], configuration)

      localVarHeaderParameter["Accept"] = "application/json"

      setSearchParams(localVarUrlObj, localVarQueryParameter)
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {}
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers
      }

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions
      }
    },
    /**
     *
     * @summary Update scoring for CREATION/REPRISE notes
     * @param {string} noteId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    updateScoringCreation: async (
      noteId: string,
      options: RawAxiosRequestConfig = {}
    ): Promise<RequestArgs> => {
      // verify required parameter 'noteId' is not null or undefined
      assertParamExists("updateScoringCreation", "noteId", noteId)
      const localVarPath = `/v2.0/scoring/creation/{noteId}`.replace(
        "{noteId}",
        encodeURIComponent(String(noteId))
      )
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL)
      let baseOptions
      if (configuration) {
        baseOptions = configuration.baseOptions
      }

      const localVarRequestOptions = { method: "POST", ...baseOptions, ...options }
      const localVarHeaderParameter = {} as any
      const localVarQueryParameter = {} as any

      // authentication oauth2 required
      // oauth required
      await setOAuthToObject(localVarHeaderParameter, "oauth2", [], configuration)

      localVarHeaderParameter["Accept"] = "application/json"

      setSearchParams(localVarUrlObj, localVarQueryParameter)
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {}
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers
      }

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions
      }
    },
    /**
     *
     * @summary Update scoring for DEVELOPMENT notes
     * @param {string} noteId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    updateScoringDevelopment: async (
      noteId: string,
      options: RawAxiosRequestConfig = {}
    ): Promise<RequestArgs> => {
      // verify required parameter 'noteId' is not null or undefined
      assertParamExists("updateScoringDevelopment", "noteId", noteId)
      const localVarPath = `/v2.0/scoring/development/{noteId}`.replace(
        "{noteId}",
        encodeURIComponent(String(noteId))
      )
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL)
      let baseOptions
      if (configuration) {
        baseOptions = configuration.baseOptions
      }

      const localVarRequestOptions = { method: "POST", ...baseOptions, ...options }
      const localVarHeaderParameter = {} as any
      const localVarQueryParameter = {} as any

      // authentication oauth2 required
      // oauth required
      await setOAuthToObject(localVarHeaderParameter, "oauth2", [], configuration)

      localVarHeaderParameter["Accept"] = "application/json"

      setSearchParams(localVarUrlObj, localVarQueryParameter)
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {}
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers
      }

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions
      }
    }
  }
}

/**
 * ScoringOctroiResourceV2Api - functional programming interface
 */
export const ScoringOctroiResourceV2ApiFp = function (configuration?: Configuration) {
  const localVarAxiosParamCreator = ScoringOctroiResourceV2ApiAxiosParamCreator(configuration)
  return {
    /**
     *
     * @summary Get note\'s scoring parameters for CREATION/REPRISE notes
     * @param {string} noteId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async checkScoringCreation(
      noteId: string,
      options?: RawAxiosRequestConfig
    ): Promise<
      (axios?: AxiosInstance, basePath?: string) => AxiosPromise<ScoringCreationParametersV2>
    > {
      const localVarAxiosArgs = await localVarAxiosParamCreator.checkScoringCreation(
        noteId,
        options
      )
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0
      const localVarOperationServerBasePath =
        operationServerMap["ScoringOctroiResourceV2Api.checkScoringCreation"]?.[
          localVarOperationServerIndex
        ]?.url
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration
        )(axios, localVarOperationServerBasePath || basePath)
    },
    /**
     *
     * @summary Get note\'s scoring parameters for DEVELOPMENT notes
     * @param {string} noteId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async checkScoringDevelopment(
      noteId: string,
      options?: RawAxiosRequestConfig
    ): Promise<
      (axios?: AxiosInstance, basePath?: string) => AxiosPromise<ScoringDeveloppementParametersV2>
    > {
      const localVarAxiosArgs = await localVarAxiosParamCreator.checkScoringDevelopment(
        noteId,
        options
      )
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0
      const localVarOperationServerBasePath =
        operationServerMap["ScoringOctroiResourceV2Api.checkScoringDevelopment"]?.[
          localVarOperationServerIndex
        ]?.url
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration
        )(axios, localVarOperationServerBasePath || basePath)
    },
    /**
     *
     * @summary Get scoring by note id
     * @param {string} noteId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async getScoring(
      noteId: string,
      options?: RawAxiosRequestConfig
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Scoring>> {
      const localVarAxiosArgs = await localVarAxiosParamCreator.getScoring(noteId, options)
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0
      const localVarOperationServerBasePath =
        operationServerMap["ScoringOctroiResourceV2Api.getScoring"]?.[localVarOperationServerIndex]
          ?.url
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration
        )(axios, localVarOperationServerBasePath || basePath)
    },
    /**
     *
     * @summary Update scoring for CREATION/REPRISE notes
     * @param {string} noteId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async updateScoringCreation(
      noteId: string,
      options?: RawAxiosRequestConfig
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Scoring>> {
      const localVarAxiosArgs = await localVarAxiosParamCreator.updateScoringCreation(
        noteId,
        options
      )
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0
      const localVarOperationServerBasePath =
        operationServerMap["ScoringOctroiResourceV2Api.updateScoringCreation"]?.[
          localVarOperationServerIndex
        ]?.url
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration
        )(axios, localVarOperationServerBasePath || basePath)
    },
    /**
     *
     * @summary Update scoring for DEVELOPMENT notes
     * @param {string} noteId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async updateScoringDevelopment(
      noteId: string,
      options?: RawAxiosRequestConfig
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Scoring>> {
      const localVarAxiosArgs = await localVarAxiosParamCreator.updateScoringDevelopment(
        noteId,
        options
      )
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0
      const localVarOperationServerBasePath =
        operationServerMap["ScoringOctroiResourceV2Api.updateScoringDevelopment"]?.[
          localVarOperationServerIndex
        ]?.url
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration
        )(axios, localVarOperationServerBasePath || basePath)
    }
  }
}

/**
 * ScoringOctroiResourceV2Api - factory interface
 */
export const ScoringOctroiResourceV2ApiFactory = function (
  configuration?: Configuration,
  basePath?: string,
  axios?: AxiosInstance
) {
  const localVarFp = ScoringOctroiResourceV2ApiFp(configuration)
  return {
    /**
     *
     * @summary Get note\'s scoring parameters for CREATION/REPRISE notes
     * @param {ScoringOctroiResourceV2ApiCheckScoringCreationRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    checkScoringCreation(
      requestParameters: ScoringOctroiResourceV2ApiCheckScoringCreationRequest,
      options?: RawAxiosRequestConfig
    ): AxiosPromise<ScoringCreationParametersV2> {
      return localVarFp
        .checkScoringCreation(requestParameters.noteId, options)
        .then(request => request(axios, basePath))
    },
    /**
     *
     * @summary Get note\'s scoring parameters for DEVELOPMENT notes
     * @param {ScoringOctroiResourceV2ApiCheckScoringDevelopmentRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    checkScoringDevelopment(
      requestParameters: ScoringOctroiResourceV2ApiCheckScoringDevelopmentRequest,
      options?: RawAxiosRequestConfig
    ): AxiosPromise<ScoringDeveloppementParametersV2> {
      return localVarFp
        .checkScoringDevelopment(requestParameters.noteId, options)
        .then(request => request(axios, basePath))
    },
    /**
     *
     * @summary Get scoring by note id
     * @param {ScoringOctroiResourceV2ApiGetScoringRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getScoring(
      requestParameters: ScoringOctroiResourceV2ApiGetScoringRequest,
      options?: RawAxiosRequestConfig
    ): AxiosPromise<Scoring> {
      return localVarFp
        .getScoring(requestParameters.noteId, options)
        .then(request => request(axios, basePath))
    },
    /**
     *
     * @summary Update scoring for CREATION/REPRISE notes
     * @param {ScoringOctroiResourceV2ApiUpdateScoringCreationRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    updateScoringCreation(
      requestParameters: ScoringOctroiResourceV2ApiUpdateScoringCreationRequest,
      options?: RawAxiosRequestConfig
    ): AxiosPromise<Scoring> {
      return localVarFp
        .updateScoringCreation(requestParameters.noteId, options)
        .then(request => request(axios, basePath))
    },
    /**
     *
     * @summary Update scoring for DEVELOPMENT notes
     * @param {ScoringOctroiResourceV2ApiUpdateScoringDevelopmentRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    updateScoringDevelopment(
      requestParameters: ScoringOctroiResourceV2ApiUpdateScoringDevelopmentRequest,
      options?: RawAxiosRequestConfig
    ): AxiosPromise<Scoring> {
      return localVarFp
        .updateScoringDevelopment(requestParameters.noteId, options)
        .then(request => request(axios, basePath))
    }
  }
}

/**
 * Request parameters for checkScoringCreation operation in ScoringOctroiResourceV2Api.
 */
export interface ScoringOctroiResourceV2ApiCheckScoringCreationRequest {
  readonly noteId: string
}

/**
 * Request parameters for checkScoringDevelopment operation in ScoringOctroiResourceV2Api.
 */
export interface ScoringOctroiResourceV2ApiCheckScoringDevelopmentRequest {
  readonly noteId: string
}

/**
 * Request parameters for getScoring operation in ScoringOctroiResourceV2Api.
 */
export interface ScoringOctroiResourceV2ApiGetScoringRequest {
  readonly noteId: string
}

/**
 * Request parameters for updateScoringCreation operation in ScoringOctroiResourceV2Api.
 */
export interface ScoringOctroiResourceV2ApiUpdateScoringCreationRequest {
  readonly noteId: string
}

/**
 * Request parameters for updateScoringDevelopment operation in ScoringOctroiResourceV2Api.
 */
export interface ScoringOctroiResourceV2ApiUpdateScoringDevelopmentRequest {
  readonly noteId: string
}

/**
 * ScoringOctroiResourceV2Api - object-oriented interface
 */
export class ScoringOctroiResourceV2Api extends BaseAPI {
  /**
   *
   * @summary Get note\'s scoring parameters for CREATION/REPRISE notes
   * @param {ScoringOctroiResourceV2ApiCheckScoringCreationRequest} requestParameters Request parameters.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   */
  public checkScoringCreation(
    requestParameters: ScoringOctroiResourceV2ApiCheckScoringCreationRequest,
    options?: RawAxiosRequestConfig
  ) {
    return ScoringOctroiResourceV2ApiFp(this.configuration)
      .checkScoringCreation(requestParameters.noteId, options)
      .then(request => request(this.axios, this.basePath))
  }

  /**
   *
   * @summary Get note\'s scoring parameters for DEVELOPMENT notes
   * @param {ScoringOctroiResourceV2ApiCheckScoringDevelopmentRequest} requestParameters Request parameters.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   */
  public checkScoringDevelopment(
    requestParameters: ScoringOctroiResourceV2ApiCheckScoringDevelopmentRequest,
    options?: RawAxiosRequestConfig
  ) {
    return ScoringOctroiResourceV2ApiFp(this.configuration)
      .checkScoringDevelopment(requestParameters.noteId, options)
      .then(request => request(this.axios, this.basePath))
  }

  /**
   *
   * @summary Get scoring by note id
   * @param {ScoringOctroiResourceV2ApiGetScoringRequest} requestParameters Request parameters.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   */
  public getScoring(
    requestParameters: ScoringOctroiResourceV2ApiGetScoringRequest,
    options?: RawAxiosRequestConfig
  ) {
    return ScoringOctroiResourceV2ApiFp(this.configuration)
      .getScoring(requestParameters.noteId, options)
      .then(request => request(this.axios, this.basePath))
  }

  /**
   *
   * @summary Update scoring for CREATION/REPRISE notes
   * @param {ScoringOctroiResourceV2ApiUpdateScoringCreationRequest} requestParameters Request parameters.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   */
  public updateScoringCreation(
    requestParameters: ScoringOctroiResourceV2ApiUpdateScoringCreationRequest,
    options?: RawAxiosRequestConfig
  ) {
    return ScoringOctroiResourceV2ApiFp(this.configuration)
      .updateScoringCreation(requestParameters.noteId, options)
      .then(request => request(this.axios, this.basePath))
  }

  /**
   *
   * @summary Update scoring for DEVELOPMENT notes
   * @param {ScoringOctroiResourceV2ApiUpdateScoringDevelopmentRequest} requestParameters Request parameters.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   */
  public updateScoringDevelopment(
    requestParameters: ScoringOctroiResourceV2ApiUpdateScoringDevelopmentRequest,
    options?: RawAxiosRequestConfig
  ) {
    return ScoringOctroiResourceV2ApiFp(this.configuration)
      .updateScoringDevelopment(requestParameters.noteId, options)
      .then(request => request(this.axios, this.basePath))
  }
}
